import config from 'config';
import { getJotformRedirectFromSignup } from 'domains/signup/signupFlow/data/jotform';
import { CompletedSignupMachineContext } from 'domains/signup/signupFlow/signupMachine';

export const getRedirectAfterSignupComplete = (context: CompletedSignupMachineContext): string => {
  if (context.insuranceInfo.useInsurance) {
    return getJotformRedirectFromSignup(context);
  }
  return config.get('marketingThankYouURL') as string;
};
